import { Spinner } from 'react-bootstrap';
import styles from './pending.module.scss';

export default function AuthPendingPage() {
    return (
        <div className={styles.container}>
            <div className={styles.pending}>
                <Spinner></Spinner>
                <div>Token ophalen...</div>
            </div>
        </div>
    )
}